module.exports = __webpack_public_path__ + "img/inactive-News2.b4ad8515.jpg";